import { useEffect, useState } from 'react'

const STORAGE_KEY = 'limpack_legal_visto_v1'

/**
 * Pill discreto que aparece la primera vez que un cliente logueado entra al panel,
 * recordándole sobre Política de Privacidad y T&C.
 * Se cierra con la ✕ y queda persistido en localStorage para no volver a mostrarse.
 *
 * Cumple con el principio de "consentimiento informado" de la Ley 18.331 UY:
 * el usuario tiene acceso permanente a las políticas (link en Cuenta) y se le
 * notifica activamente la primera vez.
 */
export default function LegalPill() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Pequeño delay para que aparezca después de que la pantalla cargó
        const t = setTimeout(() => setShow(true), 1200)
        return () => clearTimeout(t)
      }
    } catch {
      // Si localStorage está bloqueado, mostrar igual
      setShow(true)
    }
  }, [])

  function dismiss() {
    try { localStorage.setItem(STORAGE_KEY, '1') } catch {}
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="lp-pill" role="dialog" aria-label="Aviso de privacidad">
      <div className="lp-pill-icon">🔒</div>
      <div className="lp-pill-body">
        <div className="lp-pill-title">Tu privacidad importa</div>
        <div className="lp-pill-text">
          Al usar Limpack aceptás nuestra{' '}
          <a href="https://limpack.uy/privacidad" target="_blank" rel="noopener noreferrer">
            Política de Privacidad
          </a>{' '}
          y{' '}
          <a href="https://limpack.uy/terminos" target="_blank" rel="noopener noreferrer">
            Términos
          </a>.
        </div>
      </div>
      <button className="lp-pill-close" onClick={dismiss} aria-label="Cerrar">✕</button>

      <style>{`
        .lp-pill {
          position: fixed;
          left: 16px; right: 16px; bottom: 78px;
          z-index: 9999;
          display: flex; align-items: flex-start; gap: 12px;
          background: #1A3461;
          color: #fff;
          padding: 14px 16px;
          border-radius: 14px;
          box-shadow: 0 12px 32px rgba(0,0,0,.35), 0 4px 12px rgba(0,0,0,.25);
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif;
          animation: lp-pill-in .3s ease-out;
          max-width: 480px;
          margin: 0 auto;
        }
        @media (min-width: 1024px) {
          .lp-pill {
            left: 260px; right: auto; bottom: 24px;
            max-width: 420px;
          }
        }
        @keyframes lp-pill-in {
          from { transform: translateY(20px); opacity: 0; }
          to   { transform: translateY(0); opacity: 1; }
        }
        .lp-pill-icon {
          font-size: 22px; line-height: 1;
          padding-top: 2px;
          flex-shrink: 0;
        }
        .lp-pill-body { flex: 1; min-width: 0 }
        .lp-pill-title {
          font-weight: 700; font-size: 14px; margin-bottom: 4px;
          color: #fff;
        }
        .lp-pill-text {
          font-size: 13px; line-height: 1.5;
          color: rgba(255,255,255,.85);
        }
        .lp-pill-text a {
          color: #00A8B5; text-decoration: underline; font-weight: 500;
        }
        .lp-pill-text a:hover { color: #fff }
        .lp-pill-close {
          background: transparent; border: 0; color: rgba(255,255,255,.6);
          font-size: 18px; line-height: 1; cursor: pointer;
          padding: 4px 6px; border-radius: 6px;
          flex-shrink: 0;
          transition: color .15s, background .15s;
        }
        .lp-pill-close:hover { color: #fff; background: rgba(255,255,255,.1) }
      `}</style>
    </div>
  )
}
